export const AGREEMENT = 'agreement'
export const FK_BLOG_XX = 'fk_blog_xx'
export const ZD_BLOG_XX = 'zd_blog_xx'